// extracted by mini-css-extract-plugin
module.exports = {"eventProperty":"event-property_eventProperty__5AU4X"};